import React from "react";
import { Styles } from "./styles";
import MainButton from "../../common/buttons/mainButton/MainButton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Pagination } from "swiper";
import { useMediaQuery } from "../../../helpers/useMediaQuery";
import Logo from "../../../assets/images/small_logo.webp";
import ControlButtons from "./controlButtons/ControlButtons";
import BGImg from "../../../assets/images/backGrounds/contactUsBG.webp";
import { Spinner } from "react-bootstrap";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

const Metting = (props) => {
  const {
    isJoined,
    leaveChannel,
    isFullScreen,
    toggleFullScreen,
    isScreenVideoPubed,
    canPublishVideo,
    startScreenShare,
    stopScreenShare,
    isAudioPubed,
    canPublishAudio,
    isVideoPubed,
    publishVideo,
    isLoading,
    mutedUsers,
    toggleUserMute,
    remoteUserAudioTracks,
    currentMainVideos,
    publishAudio,
    joinedUsersWithNoPublish,
    handleVideoClick,
    allVideos,
    swiperRef,
    usersCount,
    toggleFullScreenVideo,
    setCurrentMainVideos,
    setAllVideos,
    setSelectedVideo,
    isVideoOn,
    selectedVideo,
    remoteUserTracks,
    config,
    TurnOffMicLoading,
    TurnOnMicLoading,
    TurnOffCameraLoading,
    TurnOnCameraLoading,
    turnOnSahreScreenLoading,
    turnOffSahreScreenLoading,
    isAudience,
    isHandRaised,
    RaiseHand,
    PutHandDown
  } = props;

  const isMobile = useMediaQuery("(max-width: 768px)");
  const isMobileDevice =
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      //|iPad
      navigator.userAgent
    );

  const { t, i18n } = useTranslation();

  const isAr = i18n.language === "ar";

  return (
    <Styles>
      <div className="agora" id="videos">
        <div id="fullScreenLoading" className="full-screen-loading">
          <Spinner size={"sm"} />{" "}
          {TurnOnCameraLoading
            ? t("loading_open_cam")
            : TurnOffCameraLoading
            ? t("loading_close_cam")
            : TurnOnMicLoading
            ? t("loading_open_mic")
            : TurnOffMicLoading
            ? t("loading_colse_mic")
            : turnOnSahreScreenLoading
            ? t("loading_open_share_screen")
            : turnOffSahreScreenLoading
            ? t("loading_close_share_screen")
            : t("finalize")}
        </div>
        {!isLoading && (
          <div className="main-container">
            {isJoined && (
              <>
                <div className="participants">
                  <i className="fa-solid fa-users"></i> {usersCount}
                </div>
                <div className="logo-container">
                  <img src={Logo} alt="darrebni" />
                </div>
              </>
            )}
            <div className="videos-container off" id="fullScreenVideo">
              {selectedVideo && (
                <div className="video-container">
                  <div className="remote-video-container">
                    <div
                      className="compress"
                      onClick={() => {
                        setAllVideos((prevTracks) => [
                          selectedVideo,
                          ...prevTracks,
                        ]);
                        setCurrentMainVideos([
                          selectedVideo,
                          ...allVideos?.slice(0, 2),
                        ]);
                        setSelectedVideo();
                        toggleFullScreenVideo();
                      }}
                    >
                      <i className="fa-solid fa-down-left-and-up-right-to-center"></i>
                    </div>

                    <video
                      id={`remote-video-${selectedVideo?.user?.uid}`}
                      ref={(videoRef) => {
                        if (videoRef && selectedVideo?.track) {
                          try {
                            selectedVideo?.track?.play(videoRef);
                          } catch (e) {
                            console.log(e);
                          }
                        }
                        // else {
                        //   selectedVideo?.track?.stop(videoRef);
                        // }
                      }}
                    ></video>
                    {remoteUserAudioTracks.some(
                      (audioTrackInfo) =>
                        audioTrackInfo?.user?.uid === selectedVideo?.user?.uid
                    ) && (
                      <MainButton
                        buttonClick={() =>
                          toggleUserMute(selectedVideo?.user?.uid)
                        }
                        buttonText={
                          mutedUsers[selectedVideo?.user?.uid] ? (
                            <i className="fa-solid fa-volume-xmark"></i>
                          ) : (
                            <i className="fa-solid fa-volume-high"></i>
                          )
                        }
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="videos-container">
              {isJoined &&
                (isVideoOn ? (
                  <div className="video-container">
                    <div className="my-video-container">
                      <video
                        id="camera-video"
                        hidden={isVideoOn ? false : true}
                      ></video>
                      <div
                        className={
                          isAr
                            ? isHandRaised
                              ? "is-hand-raised hand-up ar"
                              : "is-hand-raised ar"
                            : isHandRaised
                            ? "is-hand-raised hand-up"
                            : "is-hand-raised"
                        }
                      >
                        <i className="fa-solid fa-hand"></i> {t("raising_hand")}
                      </div>
                      <div className="data">
                        <div className="user-name">{config?.userName}</div>
                        <div className="volume">
                          {isAudioPubed && (
                            <MainButton
                              buttonText={
                                <i className="fa-solid fa-volume-high"></i>
                              }
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="video-container">
                    <div className="my-video-container">
                      <div className="bg">
                        {config?.avatar ? (
                          <img src={config?.avatar} />
                        ) : (
                          <img src={BGImg} />
                        )}
                      </div>
                      <div
                        className={
                          isAr
                            ? isHandRaised
                              ? "is-hand-raised hand-up ar"
                              : "is-hand-raised ar"
                            : isHandRaised
                            ? "is-hand-raised hand-up"
                            : "is-hand-raised"
                        }
                      >
                        <i className="fa-solid fa-hand"></i> {t("raising_hand")}
                      </div>
                      <div className="avatar">
                        {config?.avatar ? (
                          <img src={config?.avatar} />
                        ) : (
                          <div className="short-name">
                            {config?.userName
                              ?.split(" ")
                              ?.map((word) => word.charAt(0).toUpperCase())
                              ?.join(" ")
                              ?.split("")
                              ?.join(" ")}
                          </div>
                        )}
                      </div>
                      {isScreenVideoPubed && (
                        <div
                          className={
                            isAr
                              ? isHandRaised
                                ? "info hand-up ar"
                                : "info ar"
                              : isHandRaised
                              ? "info hand-up"
                              : "info"
                          }
                        >
                          (Sharing your screen)
                        </div>
                      )}
                      <div className="data">
                        <div className="user-name">{config?.userName}</div>
                        <div className="volume">
                          {isAudioPubed && (
                            <MainButton
                              buttonText={
                                <i className="fa-solid fa-volume-high"></i>
                              }
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              {currentMainVideos?.map((trackInfo, index) => (
                <div
                  className="video-container current"
                  key={`${trackInfo?.user?.uid}-${index}`}
                >
                  <div className="remote-video-container">
                    <video
                      id={`remote-video-${trackInfo?.user?.uid}`}
                      ref={(videoRef) => {
                        if (videoRef && trackInfo?.track) {
                          try {
                            trackInfo?.track?.play(videoRef);
                          } catch (e) {
                            console.log(e);
                          }
                        }
                        // else {
                        //   trackInfo?.track?.stop(videoRef);
                        // }
                      }}
                      onClick={() => {
                        setSelectedVideo(trackInfo);
                        setAllVideos(
                          allVideos?.filter((video) => video !== trackInfo)
                        );
                        setCurrentMainVideos(
                          currentMainVideos?.filter(
                            (video) => video !== trackInfo
                          )
                        );
                        toggleFullScreenVideo();
                      }}
                    ></video>
                    <div className="data">
                      <div className="user-name">
                        {trackInfo?.metadata?.name}
                      </div>
                      <div className="volume">
                        {remoteUserAudioTracks.some(
                          (audioTrackInfo) =>
                            audioTrackInfo?.user?.uid === trackInfo?.user?.uid
                        ) && (
                          <MainButton
                            buttonClick={() =>
                              toggleUserMute(trackInfo?.user?.uid)
                            }
                            buttonText={
                              mutedUsers[trackInfo?.user?.uid] ? (
                                <i className="fa-solid fa-volume-xmark"></i>
                              ) : (
                                <i className="fa-solid fa-volume-high"></i>
                              )
                            }
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {currentMainVideos?.length < 3 &&
                joinedUsersWithNoPublish?.map((userTrackInfo, index) =>
                  currentMainVideos?.length === 0
                    ? index <= 2 && (
                        <div
                          className="video-container"
                          key={`${userTrackInfo?.user?.uid}-${index}`}
                        >
                          <div className="bg">
                            {userTrackInfo?.metadata?.avatar ? (
                              <img src={userTrackInfo?.metadata?.avatar} />
                            ) : (
                              <img src={BGImg} />
                            )}
                          </div>
                          <div className="avatar">
                            {userTrackInfo?.metadata?.avatar ? (
                              <img src={userTrackInfo?.metadata?.avatar} />
                            ) : (
                              <div className="short-name">
                                {userTrackInfo?.metadata?.name
                                  ?.split(" ")
                                  ?.map((word) => word.charAt(0).toUpperCase())
                                  ?.join(" ")
                                  ?.split("")
                                  ?.join(" ")}
                              </div>
                            )}
                          </div>
                          <div className="data">
                            <div className="user-name">
                              {userTrackInfo?.metadata?.name}
                            </div>
                            <div className="volume">
                              {remoteUserAudioTracks.some(
                                (trackInfo) =>
                                  trackInfo?.user?.uid ===
                                  userTrackInfo?.user?.uid
                              ) && (
                                <MainButton
                                  buttonClick={() =>
                                    toggleUserMute(userTrackInfo?.user?.uid)
                                  }
                                  buttonText={
                                    mutedUsers[userTrackInfo?.user?.uid] ? (
                                      <i className="fa-solid fa-volume-xmark"></i>
                                    ) : (
                                      <i className="fa-solid fa-volume-high"></i>
                                    )
                                  }
                                />
                              )}
                            </div>
                          </div>
                          {/* <div className="avatar">
                            <i className="fa-regular fa-user"></i>
                            {remoteUserAudioTracks.some(
                              (trackInfo) =>
                                trackInfo?.user?.uid ===
                                userTrackInfo?.user?.uid
                            ) && (
                              <MainButton
                                buttonClick={() =>
                                  toggleUserMute(userTrackInfo?.user?.uid)
                                }
                                buttonText={
                                  mutedUsers[userTrackInfo?.user?.uid] ? (
                                    <i className="fa-solid fa-volume-xmark"></i>
                                  ) : (
                                    <i className="fa-solid fa-volume-high"></i>
                                  )
                                }
                              />
                            )}
                          </div> */}
                        </div>
                      )
                    : currentMainVideos?.length === 1
                    ? index <= 1 && (
                        <div
                          className="video-container"
                          key={`${userTrackInfo?.user?.uid}-${index}`}
                        >
                          <div className="bg">
                            {userTrackInfo?.metadata?.avatar ? (
                              <img src={userTrackInfo?.metadata?.avatar} />
                            ) : (
                              <img src={BGImg} />
                            )}
                          </div>
                          <div className="avatar">
                            {userTrackInfo?.metadata?.avatar ? (
                              <img src={userTrackInfo?.metadata?.avatar} />
                            ) : (
                              <div className="short-name">
                                {userTrackInfo?.metadata?.name
                                  ?.split(" ")
                                  ?.map((word) => word.charAt(0).toUpperCase())
                                  ?.join(" ")
                                  ?.split("")
                                  ?.join(" ")}
                              </div>
                            )}
                          </div>
                          <div className="data">
                            <div className="user-name">
                              {userTrackInfo?.metadata?.name}
                            </div>
                            <div className="volume">
                              {remoteUserAudioTracks.some(
                                (trackInfo) =>
                                  trackInfo?.user?.uid ===
                                  userTrackInfo?.user?.uid
                              ) && (
                                <MainButton
                                  buttonClick={() =>
                                    toggleUserMute(userTrackInfo?.user?.uid)
                                  }
                                  buttonText={
                                    mutedUsers[userTrackInfo?.user?.uid] ? (
                                      <i className="fa-solid fa-volume-xmark"></i>
                                    ) : (
                                      <i className="fa-solid fa-volume-high"></i>
                                    )
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      )
                    : currentMainVideos?.length === 2 &&
                      index === 0 && (
                        <div
                          className="video-container"
                          key={`${userTrackInfo?.user?.uid}-${index}`}
                        >
                          <div className="bg">
                            {userTrackInfo?.metadata?.avatar ? (
                              <img src={userTrackInfo?.metadata?.avatar} />
                            ) : (
                              <img src={BGImg} />
                            )}
                          </div>
                          <div className="avatar">
                            {userTrackInfo?.metadata?.avatar ? (
                              <img src={userTrackInfo?.metadata?.avatar} />
                            ) : (
                              <div className="short-name">
                                {userTrackInfo?.metadata?.name
                                  ?.split(" ")
                                  ?.map((word) => word.charAt(0).toUpperCase())
                                  ?.join(" ")
                                  ?.split("")
                                  ?.join(" ")}
                              </div>
                            )}
                          </div>
                          <div className="data">
                            <div className="user-name">
                              {userTrackInfo?.metadata?.name}
                            </div>
                            <div className="volume">
                              {remoteUserAudioTracks.some(
                                (trackInfo) =>
                                  trackInfo?.user?.uid ===
                                  userTrackInfo?.user?.uid
                              ) && (
                                <MainButton
                                  buttonClick={() =>
                                    toggleUserMute(userTrackInfo?.user?.uid)
                                  }
                                  buttonText={
                                    mutedUsers[userTrackInfo?.user?.uid] ? (
                                      <i className="fa-solid fa-volume-xmark"></i>
                                    ) : (
                                      <i className="fa-solid fa-volume-high"></i>
                                    )
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      )
                )}
            </div>
            {usersCount > 4 && (
              <Swiper
                direction={isMobile ? "horizontal" : "vertical"}
                slidesPerView={3}
                mousewheel={true}
                ref={swiperRef}
                // loop={true}
                pagination={{
                  type: "progressbar",
                }}
                modules={[Mousewheel, Pagination]}
                spaceBetween={10}
                id="swiper"
              >
                {allVideos?.map(
                  (trackInfo, index) =>
                    currentMainVideos?.every(
                      (mainVideo) =>
                        mainVideo?.user?.uid !== trackInfo?.user?.uid
                    ) && (
                      <SwiperSlide key={`${trackInfo?.user?.uid}-${index}`}>
                        <div className="video-container">
                          <div
                            className="remote-video-container"
                            onClick={() => handleVideoClick(index)}
                          >
                            <video
                              id={`remote-video-${trackInfo?.user?.uid}`}
                              ref={(videoRef) => {
                                if (videoRef && trackInfo?.track) {
                                  try {
                                    trackInfo?.track?.play(videoRef);
                                  } catch (e) {
                                    console.log(e);
                                  }
                                }
                                // else {
                                //   trackInfo?.track?.stop(videoRef);
                                // }
                              }}
                            ></video>
                            <div className="data">
                              <div className="user-name">
                                {trackInfo?.metadata?.name}
                              </div>
                              <div className="volume">
                                {remoteUserAudioTracks.some(
                                  (AudiotrackInfo) =>
                                    AudiotrackInfo?.user?.uid ===
                                    trackInfo?.user?.uid
                                ) && (
                                  <MainButton
                                    buttonClick={() =>
                                      toggleUserMute(trackInfo?.user?.uid)
                                    }
                                    buttonText={
                                      mutedUsers[trackInfo?.user?.uid] ? (
                                        <i className="fa-solid fa-volume-xmark"></i>
                                      ) : (
                                        <i className="fa-solid fa-volume-high"></i>
                                      )
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    )
                )}
                {joinedUsersWithNoPublish?.map((userTrackInfo, index) =>
                  // remoteUserTracks.every(
                  //   (trackInfo) =>
                  //     trackInfo.user.uid !== userTrackInfo.user.uid
                  // ) &&
                  currentMainVideos?.length === 0
                    ? index > 2 && (
                        <SwiperSlide
                          key={`${userTrackInfo?.user?.uid}-${index}`}
                        >
                          <div className="video-container">
                            <div className="bg">
                              {userTrackInfo?.metadata?.avatar ? (
                                <img src={userTrackInfo?.metadata?.avatar} />
                              ) : (
                                <img src={BGImg} />
                              )}
                            </div>
                            <div className="avatar">
                              {userTrackInfo?.metadata?.avatar ? (
                                <img src={userTrackInfo?.metadata?.avatar} />
                              ) : (
                                <div className="short-name">
                                  {userTrackInfo?.metadata?.name
                                    ?.split(" ")
                                    ?.map((word) =>
                                      word.charAt(0).toUpperCase()
                                    )
                                    ?.join(" ")
                                    ?.split("")
                                    ?.join(" ")}
                                </div>
                              )}
                            </div>
                            <div className="data">
                              <div className="user-name">
                                {userTrackInfo?.metadata?.name}
                              </div>
                              <div className="volume">
                                {remoteUserAudioTracks.some(
                                  (trackInfo) =>
                                    trackInfo?.user?.uid ===
                                    userTrackInfo?.user?.uid
                                ) && (
                                  <MainButton
                                    buttonClick={() =>
                                      toggleUserMute(userTrackInfo?.user?.uid)
                                    }
                                    buttonText={
                                      mutedUsers[userTrackInfo?.user?.uid] ? (
                                        <i className="fa-solid fa-volume-xmark"></i>
                                      ) : (
                                        <i className="fa-solid fa-volume-high"></i>
                                      )
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                    : currentMainVideos?.length === 1
                    ? index > 1 && (
                        <SwiperSlide
                          key={`${userTrackInfo?.user?.uid}-${index}`}
                        >
                          <div className="video-container">
                            <div className="bg">
                              {userTrackInfo?.metadata?.avatar ? (
                                <img src={userTrackInfo?.metadata?.avatar} />
                              ) : (
                                <img src={BGImg} />
                              )}
                            </div>
                            <div className="avatar">
                              {userTrackInfo?.metadata?.avatar ? (
                                <img src={userTrackInfo?.metadata?.avatar} />
                              ) : (
                                <div className="short-name">
                                  {userTrackInfo?.metadata?.name
                                    ?.split(" ")
                                    ?.map((word) =>
                                      word.charAt(0).toUpperCase()
                                    )
                                    ?.join(" ")
                                    ?.split("")
                                    ?.join(" ")}
                                </div>
                              )}
                            </div>
                            <div className="data">
                              <div className="user-name">
                                {userTrackInfo?.metadata?.name}
                              </div>
                              <div className="volume">
                                {remoteUserAudioTracks.some(
                                  (trackInfo) =>
                                    trackInfo?.user?.uid ===
                                    userTrackInfo?.user?.uid
                                ) && (
                                  <MainButton
                                    buttonClick={() =>
                                      toggleUserMute(userTrackInfo?.user?.uid)
                                    }
                                    buttonText={
                                      mutedUsers[userTrackInfo?.user?.uid] ? (
                                        <i className="fa-solid fa-volume-xmark"></i>
                                      ) : (
                                        <i className="fa-solid fa-volume-high"></i>
                                      )
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                    : currentMainVideos?.length === 2
                    ? index > 0 && (
                        <SwiperSlide
                          key={`${userTrackInfo?.user?.uid}-${index}`}
                        >
                          <div className="video-container">
                            <div className="bg">
                              {userTrackInfo?.metadata?.avatar ? (
                                <img src={userTrackInfo?.metadata?.avatar} />
                              ) : (
                                <img src={BGImg} />
                              )}
                            </div>
                            <div className="avatar">
                              {userTrackInfo?.metadata?.avatar ? (
                                <img src={userTrackInfo?.metadata?.avatar} />
                              ) : (
                                <div className="short-name">
                                  {userTrackInfo?.metadata?.name
                                    ?.split(" ")
                                    ?.map((word) =>
                                      word.charAt(0).toUpperCase()
                                    )
                                    ?.join(" ")
                                    ?.split("")
                                    ?.join(" ")}
                                </div>
                              )}
                            </div>
                            <div className="data">
                              <div className="user-name">
                                {userTrackInfo?.metadata?.name}
                              </div>
                              <div className="volume">
                                {remoteUserAudioTracks.some(
                                  (trackInfo) =>
                                    trackInfo?.user?.uid ===
                                    userTrackInfo?.user?.uid
                                ) && (
                                  <MainButton
                                    buttonClick={() =>
                                      toggleUserMute(userTrackInfo?.user?.uid)
                                    }
                                    buttonText={
                                      mutedUsers[userTrackInfo?.user?.uid] ? (
                                        <i className="fa-solid fa-volume-xmark"></i>
                                      ) : (
                                        <i className="fa-solid fa-volume-high"></i>
                                      )
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                    : currentMainVideos?.length > 2 && (
                        <SwiperSlide
                          key={`${userTrackInfo?.user?.uid}-${index}`}
                        >
                          <div className="video-container">
                            <div className="bg">
                              {userTrackInfo?.metadata?.avatar ? (
                                <img src={userTrackInfo?.metadata?.avatar} />
                              ) : (
                                <img src={BGImg} />
                              )}
                            </div>
                            <div className="avatar">
                              {userTrackInfo?.metadata?.avatar ? (
                                <img src={userTrackInfo?.metadata?.avatar} />
                              ) : (
                                <div className="short-name">
                                  {userTrackInfo?.metadata?.name
                                    ?.split(" ")
                                    ?.map((word) =>
                                      word.charAt(0).toUpperCase()
                                    )
                                    ?.join(" ")
                                    ?.split("")
                                    ?.join(" ")}
                                </div>
                              )}
                            </div>
                            <div className="data">
                              <div className="user-name">
                                {userTrackInfo?.metadata?.name}
                              </div>
                              <div className="volume">
                                {remoteUserAudioTracks.some(
                                  (trackInfo) =>
                                    trackInfo?.user?.uid ===
                                    userTrackInfo?.user?.uid
                                ) && (
                                  <MainButton
                                    buttonClick={() =>
                                      toggleUserMute(userTrackInfo?.user?.uid)
                                    }
                                    buttonText={
                                      mutedUsers[userTrackInfo?.user?.uid] ? (
                                        <i className="fa-solid fa-volume-xmark"></i>
                                      ) : (
                                        <i className="fa-solid fa-volume-high"></i>
                                      )
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                )}
              </Swiper>
            )}
          </div>
        )}
        {!isLoading && isJoined && (
          <ControlButtons
            isJoined={isJoined}
            leaveChannel={leaveChannel}
            isFullScreen={isFullScreen}
            toggleFullScreen={toggleFullScreen}
            isScreenVideoPubed={isScreenVideoPubed}
            canPublishVideo={canPublishVideo}
            startScreenShare={startScreenShare}
            stopScreenShare={stopScreenShare}
            isMobileDevice={isMobileDevice}
            isAudioPubed={isAudioPubed}
            canPublishAudio={canPublishAudio}
            publishAudio={publishAudio}
            isVideoPubed={isVideoPubed}
            publishVideo={publishVideo}
            isAudience={isAudience}
            isHandRaised={isHandRaised}
            RaiseHand={RaiseHand}
            PutHandDown={PutHandDown}
          />
        )}
      </div>
    </Styles>
  );
};

export default Metting;
